import Vue from 'vue';
import Router from 'vue-router';
import layout from '../components/layout/layout';
import index from '../components/content/index';
import foot from '../components/footer/foot';
import ActivityList from "../components/content/ActivityList";
import News from "../components/content/News";
import Dynamic from "../components/content/Dynamic";
import LogoNav from "../components/header/LogoNav";
import ActivityInfo from "../components/content/ActivityInfo";
import NewsInfo from "../components/content/NewsInfo";
import DynamicInfo from "../components/content/DynamicInfo";
import Events from "../components/content/Events";
import Register from "../components/sign/Register";
import Login from "../components/sign/Login";
import ResetPassword from "../components/sign/ResetPassword";
import MemberInfo from "../components/content/MemberInfo";
import RegisterCompany from "../components/sign/RegisterCompany";
import UserCenter from "../components/user/UserCenter";
import SocietyInfo from "../components/content/SocietyInfo";
import Apply from "../components/content/Apply";


Vue.use(Router);
import store from '../store';
import OrgCenter from "../components/user/OrgCenter";


const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/scf',
      name: '',
      component: layout,
      children: [
        {
          path: '',
          name: 'scf',
          components: {
            head: LogoNav,
            content: index,
            foot: foot
          }
        },
        {
          path: 'activity',
          name: 'activity',
          components: {
            head: LogoNav,
            content: ActivityList,
            foot: foot
          }
        },
        {
          path: 'news',
          name: 'news',
          components: {
            head: LogoNav,
            content: News,
            foot: foot
          }
        },
        {
          path: 'dynamic',
          name: 'dynamic',
          components: {
            head: LogoNav,
            content: Dynamic,
            foot: foot
          }
        },


        {
          path: 'member/:id',
          name: 'member',
          components: {
            head: LogoNav,
            content: MemberInfo,
            foot: foot
          },
          props: {head: false, content: true, foot: false}
        },
        {
          path: 'society/:id',
          name: 'society',
          components: {
            head: LogoNav,
            content: SocietyInfo,
            foot: foot
          },
          props: {head: false, content: true, foot: false}
        },

        {
          path: 'events',
          name: 'events',
          components: {
            head: LogoNav,
            content: Events,
            foot: foot
          }
        },
        {
          path: 'center/user',
          name: 'center',
          components: {
            head: LogoNav,
            content: UserCenter,
            foot: foot
          }
        },
        {
          path: 'center/org',
          name: 'orgCenter',
          components: {
            head: LogoNav,
            content: OrgCenter,
            foot: foot
          }
        },

        {
          path: 'activity/:id',
          name: 'activityInfo',
          components: {
            head: LogoNav,
            content: ActivityInfo,
            foot: foot
          },
          props: {head: false, content: true, foot: false}

        },
        {
          path: 'news/:id',
          name: 'newsInfo',
          components: {
            head: LogoNav,
            content: NewsInfo,
            foot: foot
          },
          props: {head: false, content: true, foot: false}

        },
        {
          path: 'dynamic/:id',
          name: 'dynamicInfo',
          components: {
            head: LogoNav,
            content: DynamicInfo,
            foot: foot
          },
          props: {head: false, content: true, foot: false}

        },
        {
          path: 'apply/:id',
          name: 'apply',
          components: {
            head: LogoNav,
            content: Apply,
            foot: foot
          },
          props: {head: false, content: true, foot: false}

        },

      ]
    },
    {
      path: '/scf/register',
      name: 'register',
      component: Register
    },
    {
      path: '/scf/register/company',
      name: 'registercompany',
      component: RegisterCompany
    },
    {
      path: '/scf/login',
      name: 'login',
      component: Login
    },
    {
      path: '/scf/reset',
      name: 'reset',
      component: ResetPassword
    },
  ]
});

// // 为进入页面进行导航守卫
// router.beforeEach((to, from, next) => {
//
//   let url = store.getters.url;
//   let part = store.getters.userInfo.part;
//   let uid = store.getters.userInfo.uid;
//
//   let reg1 = /^\/scf\/center/i;
//   let reg2 = /^\/scf\/centerOrg/i;
//   console.log('--to',to);
//   console.log('--part',part);
//   console.log('--from',from);
//   console.log('--uid',uid);
//
//   //未登录不能进入用户中心
//   if (!reg1.test(to.path) && !reg2.test(to.path )){
//     next();
//   } else if (reg2.test(to.path )&& uid && typeof (uid) !== 'undefined' && part === 'O') {
//     next();
//   } else if (reg1.test(to.path )&& uid && typeof (uid) !== 'undefined' && part === 'P') {
//     next({name: 'center'});
//   } else {
//     next({name: 'scf'});
//   }
//
//
// });

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js